import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from 'src/app/shared';

@Pipe({
  name: 'dischargestatus'
})
export class DischargestatusPipe implements PipeTransform {

  constructor(private userService : UserService) {}
  transform(value: any): any {

    if (value != null && value != "") {
      if (value == "InProgress") {
        return this.userService.translateText('hospital_portal.patientls.current.option');
      }
      else if (value == "UpComing") {
        return this.userService.translateText('patient_portal.activity_board.upcoming.label');
      }
      else if (value == "ReAdmitPending") {
        return this.userService.translateText('patient_portal.activity_board.readmission_pending.label');
      }
      else if (value == "EdPending") {
        return this.userService.translateText('patient_portal.activity_board.ed_visit.label');
      }
      else if (value == "Completed") {
        return this.userService.translateText('hospital_portal.mytodos.completed.label');
      }
      else if (value == "Actual") {
        return this.userService.translateText('hospital_portal.summary.actual.label');
      }
    }
    return value;
  }

}
